import classNames from 'classnames';

import { LAYOUTS, canPlace } from '../../../functions/dayLimit';

import './styles.scss';

// Picks an event's size and place in its day: one block per size, each showing where an event of that size can
// stand. A place another event takes, or that the day has no room for, is crossed out.
// value and onChange are { width, height, pos_x, pos_y }.
function EventLayout({ dayEvents, event, value, onChange }) {
    return (
        <div className="event-layout" role="group" aria-label="Расположение события">
            {LAYOUTS.map(layout => {
                const places = layout.spots.map(([pos_x, pos_y]) => ({ width: layout.width, height: layout.height, pos_x, pos_y }));
                const isSelected = (place) => value != null && place.width === value.width && place.height === value.height
                    && place.pos_x === value.pos_x && place.pos_y === value.pos_y;
                return (
                    <div key={layout.key} className="event-layout-size">
                        <div
                            className={classNames('event-layout-day', { 'event-layout-day_selected': places.some(isSelected) })}
                            title={layout.label}
                            aria-label={layout.label}
                            role="group"
                        >
                            {places.map(place => {
                                const free = canPlace(dayEvents, event, place);
                                return (
                                    <button
                                        type="button"
                                        key={`${place.pos_x}-${place.pos_y}`}
                                        disabled={!free}
                                        title={free ? undefined : 'Место занято'}
                                        className={classNames('event-layout-spot', `event-layout-spot_${layout.key}`, {
                                            'event-layout-spot_selected': isSelected(place),
                                        })}
                                        style={{
                                            gridColumn: `${place.pos_x + 1} / span ${place.width / 50}`,
                                            gridRow: `${place.pos_y + 1} / span ${place.height / 50}`,
                                        }}
                                        onClick={() => onChange(place)}
                                    />
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export { EventLayout };
